"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ExternalButton = /** @class */ (function () {
    function ExternalButton() {
    }
    ExternalButton.prototype.init = function (selector, callback, enabled) {
        var _this = this;
        if (enabled === void 0) { enabled = true; }
        this.$el = $(selector);
        this.callback = callback;
        this.$el.click(function () {
            _this.callback();
        });
        this.enable(enabled);
        return this.$el.length > 0;
    };
    ExternalButton.prototype.enable = function (enable) {
        if (enable === void 0) { enable = true; }
        if (!this.$el) {
            return;
        }
        if (enable) {
            this.$el.removeAttr('disabled');
        }
        else {
            this.$el.attr('disabled', '');
        }
    };
    return ExternalButton;
}());
exports.ExternalButton = ExternalButton;
exports.default = angular.module('pb.externalButton', [])
    .service('externalButton', ExternalButton);
